import edition1 from '../editions/1';
import edition2 from '../editions/2';
import edition3 from '../editions/3';
import edition4 from '../editions/4';

export default {
  1: edition1,
  2: edition2,
  3: edition3,
  4: edition4
};
